import React from "react";
import styled from "styled-components";
import { PageSection } from "../../../components/Page";
import { ValueHypothesisReport } from "../../ValueHypothesis";
import PropType from "prop-types";
import MobileReportSection from "./MobileReportSection";
import { useMobileMediaQuery } from "../../../components/Responsive";
import CostOfStatusQuoChartProvider from "../../ValueHypothesis/components/CostOfStatusQuoChartProvider";
import ValueHypothesisProvider from "../../ValueHypothesis/components/ValueHypothesisProvider";

const ReportValueHypothesis = ({ reportId }) => {
  const isMobile = useMobileMediaQuery();
  return isMobile ? (
    <MobileReportSection id={"report-value-hypothesis"}>
      <ValueHypothesisProvider reportMode={true}>
        <CostOfStatusQuoChartProvider>
          <ValueHypothesisReport reportId={reportId} />
        </CostOfStatusQuoChartProvider>
      </ValueHypothesisProvider>
    </MobileReportSection>
  ) : (
    <ReportROIContainer id={"report-value-hypothesis"}>
      <ValueHypothesisProvider reportMode={true}>
        <CostOfStatusQuoChartProvider>
          <ValueHypothesisReport reportId={reportId} />
        </CostOfStatusQuoChartProvider>
      </ValueHypothesisProvider>
    </ReportROIContainer>
  );
};

const ReportROIContainer = styled(PageSection)`
  padding: 120px 24px;
  @media print {
    padding: 0;
  }
  width: 100%;
`;

ReportValueHypothesis.propTypes = {
  reportId: PropType.string.isRequired
};

export default ReportValueHypothesis;
